'use client';

import type { FunctionComponent } from 'react';
import { HiChevronUp } from 'react-icons/hi';

const MobileMapChevron: FunctionComponent = () => {
    const scrollTop = () => {
        window.scrollTo({ top: 400, behavior: 'smooth' });
    };

    return (
        <div className="text-primary absolute -top-9 left-0 w-full text-center md:hidden">
            <div
                className="drop-shadow-t-lg bg-lightest-grey inline-block cursor-pointer rounded-t-full px-4 py-2 text-2xl"
                onClick={scrollTop}>
                <HiChevronUp aria-hidden aria-label="Deschide lista de locații" />
            </div>
        </div>
    );
};

MobileMapChevron.displayName = 'MobileMapChevron';

export default MobileMapChevron;
